import { appStyles } from '../App.styles';
export const /** InfobaseTableSG's Styles */ infobaseTableSGStyles = {
    tableCell: {
        color: 'black.main',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    tooltip: Object.assign(Object.assign({}, appStyles.text12), { color: 'whiteDark.main', backgroundColor: 'blackLighter.main', padding: '0.25rem 0.5rem', maxWidth: '12.5rem', boxSizing: 'border-box' }),
};
